import { useInView } from 'react-intersection-observer';
import { useEffect, useRef } from 'react';


function VideoIntersection({animate, ...props}) {
   const vidref = useRef(null);
   const video= props.src;
   const poster = props.poster ? props.poster : '';
   const loop = false;

   const { ref, inView } = useInView({
      threshold: 0.1,
      delay: 500
    });

   useEffect(() => {
      let length = vidref.current.duration;
      if (animate && inView) {
         vidref.current.play();
      } else if (animate && !inView) {
         vidref.current.currentTime = 0;
         vidref.current.pause() 
      } else if (!animate) {
         if (!isNaN(length)) {
            vidref.current.currentTime = length - 0.001;
            vidref.current.pause();
         }
      }
   })

   return (
     <div className={props.hero ? 'video hero' : 'video'} ref={ref}>
         <video autoplay loop={loop} webkit-playsinline playsInline muted ref={vidref} poster={poster} class="i2">
            <source src={video} type="video/mp4" />
         </video>
     </div>
   );
 }
 
 export default VideoIntersection;